//=require popper.js/dist/umd/popper.min.js
//=require bootstrap/dist/js/bootstrap.min.js
//enable Bootstrap 4 pop overs
$(function () {
    // $('[data-toggle="popover"]').popover({html: true})
});
//enable Bootstrap 4 tool tips
$(function () {
    // $('[data-toggle="tooltip"]').tooltip({html: true})
});

(function(window, $, undefined){
  /*
   * This block defines functionality to support JVZoo's implementation of Bootstrap
   */
  window.JVZoo = window.JVZoo || {};
  window.JVZoo.Bootstrap = window.JVZoo.Bootstrap || {};

  /**
   * 2018-12-02 Adam Lenda
   * Constructs a function that looks for an element with an attribute like:
   * data-jvz-content-for="contentDestinationId"
   *
   * If the element exists, then this function will return a function that
   * retrieves the html content
   *
   * @param contentDestinationId
   * @returns {*}
   */
  var buildGetJvzContentFor = function(contentDestinationId) {
    if (!contentDestinationId) {
      //Unable to build a function to fetch content for an element that does not have an id value.
      return null;
    }
    var selector = "[data-jvz-content-for='"+contentDestinationId+"']";
    var sourceElement = $(selector);
    if (!sourceElement || sourceElement.length < 1) {
      console.error("Unable to locate an element matching the selector: ", selector);
      return null;
    }
    return function() {
      return sourceElement.html()
    }
  };

  window.JVZoo.Bootstrap.applyBindings = function($root) {
    // Bind popover elements
    $root
      .find("[data-toggle=popover]")
      .each(function(index, element) {
        var $element = $(element);
        var getContentFunction = buildGetJvzContentFor($element.attr('id'));
        if (getContentFunction) {
          var popoverConfiguration = {
            delay:{show: 100, hide: 2000},
            html: true,
            content: getContentFunction
          };
          $element.popover(popoverConfiguration);
        } else {
            // this is just a normal popover that manages it's own content
            $element.popover({html: true})
        }
      });
  };

  $(document).ready(function() {
    window.JVZoo.Bootstrap.applyBindings($(document));
  });
})(window, jQuery);